import get from 'lodash/get';
import { takeLatest, put, call, select, all } from 'redux-saga/effects';
import { postMissingPoints } from 'yoda-interfaces/lib/Rewards/RewardsApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import * as MissingPointsActionTypes from '../actionTypes/MissingPointsActionsTypes';
import getSettings from './selectors';

export function* postMissingPointsSaga(action) {
    try {
        const missingData = get(yield call(FactorySaga, postMissingPoints, action), 'response', {});
        missingData.showMessageBox = true;
        const settings = yield select(getSettings);
        const { preferences, messagesTexts } = settings;
        if (missingData.status === 200) {
            missingData.messageType = 'success';
            missingData.showSuccess = true;
            missingData.messageInput = preferences.missingPointsSettings.successMessage;
            yield put({ type: MissingPointsActionTypes.ACCOUNT_TRACK_OPEN_MISSING_MODAL_SUCCESS });
        } else if (missingData.status !== 200 && !missingData.data.errorMessage) {
            missingData.messageType = 'error';
            missingData.messageInput = messagesTexts.missingPoints.defaultError;
        } else if (missingData.status === 401) {
            missingData.showMessageBox = false;
            missingData.messageType = '';
        } else {
            missingData.messageType = 'error';
            missingData.messageInput = missingData.data.errorMessage;
            missingData.errorScenarios = messagesTexts.missingPoints.errorScenarios;
        }
        yield put({
            type: MissingPointsActionTypes.ACCOUNT_POST_MISSING_POINTS_SUCCESS,
            missingData,
        });

        if (missingData.messageType === 'error') {
            yield put({
                type: MissingPointsActionTypes.ACCOUNT_TRACK_OPEN_MISSING_MODAL_ERROR,
                payload: missingData.messageInput,
            });
        }

        if (missingData) {
            yield put({ type: MissingPointsActionTypes.GET_MISSING_POINTS_DETAILS });
        }
    } catch (error) {
        yield all([
            put({
                type: MissingPointsActionTypes.ACCOUNT_POST_MISSING_POINTS_ERROR,
                error,
            }),
            put({
                type: MissingPointsActionTypes.ACCOUNT_TRACK_OPEN_MISSING_MODAL_ERROR,
                payload: error,
            }),
        ]);
    }
}

const watchMissingPointsSaga = function* watchMissingPointsSaga() {
    yield takeLatest(MissingPointsActionTypes.ACCOUNT_POST_MISSING_POINTS, postMissingPointsSaga);
};

watchMissingPointsSaga.sagaName = 'missingPointsSaga';

export default watchMissingPointsSaga;
